import { Box, SxProps } from '@mui/material';
import { SearchFilterType } from '../usePopover';
import {
  api_portalOfficeHospitalListing_responseFilter,
  api_portalOfficeHospitalListing_medicalSubject,
  api_portalOfficeHospitalListing_reportedAdditionalFee,
} from '@/init/swagger';
import { MedicalSubjectContent } from './MedicalSubjectContent';
import { MedicalCareContent } from './MedicalCareContent';
import { AppealPointsContent } from './AppealPointsContent';
import { RequireLoginContent } from './RequireLoginContent';

const containerStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '880px',
  px: 5,
  py: 3,
  gap: 3,
  '@media (max-width: 880px)': {
    width: '100%',
    px: 3,
    py: 3,
  },
};

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
  hospitalReportedAdditionalFees: api_portalOfficeHospitalListing_reportedAdditionalFee[];
  hospitalMedicalCares: api_portalOfficeHospitalListing_responseFilter[];
  hospitalAppealPoints: api_portalOfficeHospitalListing_responseFilter[];
  searchFilterType: SearchFilterType;
  search: () => Promise<void>;
  close: () => void;
};

export function PopoverContentContainer({
  hospitalMedicalSubjects,
  hospitalReportedAdditionalFees,
  hospitalMedicalCares,
  hospitalAppealPoints,
  searchFilterType,
  search,
  close,
}: Props) {
  return (
    <>
      {searchFilterType === 'medicalSubject' && (
        <Box sx={containerStyle}>
          <MedicalSubjectContent
            hospitalMedicalSubjects={hospitalMedicalSubjects}
            hospitalReportedAdditionalFees={hospitalReportedAdditionalFees}
            search={search}
            close={close}
          />
        </Box>
      )}
      {searchFilterType === 'medicalCare' && (
        <Box sx={containerStyle}>
          <MedicalCareContent
            hospitalMedicalCares={hospitalMedicalCares}
            search={search}
            close={close}
          />
        </Box>
      )}
      {searchFilterType === 'appealPoint' && (
        <Box sx={containerStyle}>
          <AppealPointsContent
            hospitalAppealPoints={hospitalAppealPoints}
            search={search}
            close={close}
          />
        </Box>
      )}
      {searchFilterType === 'loginRequire' && <RequireLoginContent />}
    </>
  );
}
